<template>
  <section class="select-template">
    <p class="gallery-intro" ref="gallery">
      Tank jõulukaardi&shy;generaatori abil saad paigutada oma kauni näolapi meeleolukasse jõulu&shy;situatsiooni.
      Kõigepealt...
    </p>

    <header>
      <h3>Vali pilt</h3>
    </header>

    <div class="template-gallery">
      <div class="template-gallery__template" v-for="(template, i) in templates" :key="i">
        <label :class="imageClass(template.image)">
          <input type="radio" :value="template.image" v-model="image" name="template" />
          <img :data-src="template.image" />
        </label>
        <button @click="image = null" v-show="image === template.image" type="button" class="template-gallery__cancel">
          &times;
        </button>
        <button @click="submit" v-show="image === template.image" type="button" class="template-gallery__select">
          Vali
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import image1 from '@/assets/imageTemplates/l1.png'
import image2 from '@/assets/imageTemplates/l2.png'
import image3 from '@/assets/imageTemplates/l3.png'
import image4 from '@/assets/imageTemplates/l4.png'
import image5 from '@/assets/imageTemplates/l5.png'
import image6 from '@/assets/imageTemplates/p1.png'
import image7 from '@/assets/imageTemplates/p2.png'
import image8 from '@/assets/imageTemplates/p3.png'
import image9 from '@/assets/imageTemplates/p4.png'
import image10 from '@/assets/imageTemplates/p5.png'
import image11 from '@/assets/imageTemplates/p6.png'
import image12 from '@/assets/imageTemplates/p7.png'
import image13 from '@/assets/imageTemplates/p8.png'
import image14 from '@/assets/imageTemplates/r1.png'
import image15 from '@/assets/imageTemplates/r2.png'
import image16 from '@/assets/imageTemplates/r3.png'
import image17 from '@/assets/imageTemplates/r4.png'
import image18 from '@/assets/imageTemplates/r5.png'

export default {
  name: 'select-template',
  data() {
    return {
      image: null,
      // Define how to manipulate the avatar per template
      templates: [
        {
          image: image1,
          size: 0.1,
          x: 0.29,
          y: 0.1
        },
        {
          image: image2,
          size: 0.1,
          x: 0.05,
          y: 0.18
        },
        {
          image: image3,
          size: 0.15,
          x: 0.34,
          y: 0.045
        },
        {
          image: image4,
          size: 0.25,
          x: 0.59,
          y: 0.4
        },
        {
          image: image5,
          size: 0.12,
          x: 0.44,
          y: 0.16
        },
        {
          image: image6,
          size: 0.175,
          x: 0.44,
          y: 0.43
        },
        {
          image: image7,
          size: 0.09,
          x: 0.58,
          y: 0.1
        },
        {
          image: image8,
          size: 0.14,
          x: 0.44,
          y: 0.13
        },
        {
          image: image9,
          size: 0.06,
          x: 0.45,
          y: 0.34
        },
        {
          image: image10,
          size: 0.08,
          x: 0.56,
          y: 0.15
        },
        {
          image: image11,
          size: 0.1,
          x: 0.46,
          y: 0.21
        },
        {
          image: image12,
          size: 0.07,
          x: 0.5,
          y: 0.42
        },
        {
          image: image13,
          size: 0.12,
          x: 0.31,
          y: 0.24
        },
        {
          image: image14,
          size: 0.18,
          x: 0.37,
          y: 0.08
        },
        {
          image: image15,
          size: 0.1,
          x: 0.24,
          y: 0.18
        },
        {
          image: image16,
          size: 0.18,
          x: 0.57,
          y: 0.36
        },
        {
          image: image17,
          size: 0.18,
          x: 0.22,
          y: 0.22
        },
        {
          image: image18,
          size: 0.2,
          x: 0.53,
          y: 0.18
        }
      ]
    }
  },
  props: ['value'],
  async mounted() {
    if (window.IntersectionObserver) {
      let observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.src = entry.target.dataset.src
              observer.unobserve(entry.target)
            }
          })
        },
        { rootMargin: '0px 0px -100px 0px' }
      )
      this.$el.querySelectorAll('img').forEach(img => {
        observer.observe(img)
      })
    }
  },
  methods: {
    imageClass(img) {
      return this.image && this.image !== img ? '-faded' : null
    },
    submit() {
      this.$emit(
        'input',
        this.templates.find(template => template.image === this.image)
      )
    }
  }
}
</script>

<style lang="scss">
.select-template {
  h3 {
    font-size: 3em;
    text-align: center;
    margin-bottom: 2rem;
    font-weight: 900;
  }
}
.template-gallery {
  display: grid;
  align-items: center;
  grid-auto-flow: row;
  grid-gap: 20px;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  justify-content: space-between;
  margin: 0 0.5rem 7rem;

  @media screen and (min-width: 50rem) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }

  input {
    display: none;

    &:checked + img {
      opacity: 1;
    }
  }
  button {
    text-transform: uppercase;
  }
  .template-gallery__template {
    position: relative;
  }
  .template-gallery__select {
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translateY(40%);
    text-shadow: 1px 1px 4px rgba(50, 50, 50, 0.4);
  }
  .template-gallery__cancel {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 4rem;
  }
  label {
    position: relative;
    display: block;
    transition: opacity 0.3s;
    cursor: pointer;
  }
  img {
    transition: opacity 0.2s;
    object-fit: contain;
    border-radius: 3px;
  }
  .-faded {
    opacity: 0.4;
  }
}
</style>
